import { render, staticRenderFns } from "./labDetail.vue?vue&type=template&id=bd0b09a4&scoped=true"
import script from "./labDetail.vue?vue&type=script&lang=js"
export * from "./labDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0b09a4",
  null
  
)

export default component.exports